/* js/layout.js */

;document.documentElement.className += " js";

// if(typeof window.getComputedStyle(document.body).backgroundBlendMode == 'undefined') {
//     document.documentElement.className += " no-background-blend-mode";
// } 

if(Modernizr.touch) {
    document.documentElement.className += " is-touch";
} else {
    document.documentElement.className += " no-touch";
}
